import React from 'react';

import CardFooter from './CardFooter';

export function OverviewFooter(props) {   
    return (<CardFooter/>);
}



// WEBPACK FOOTER //
// ./src/react/card/OverviewFooter.jsx